
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hydSe", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");

var $luv00 = parcelRequire("luv00");


var $gz8ZY = parcelRequire("gz8ZY");


var $2to2n = parcelRequire("2to2n");


const $bb63054715080228$export$e1b8a1ae03e64401 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9_LXb",
    name: "ContextualCreateContentPopoverLoader",
    loader: async ()=>(await (parcelRequire("a4AqN"))).ContextualCreateContentPopover
});
const $bb63054715080228$export$1546232e68d28255 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { spaceKey: spaceKey, source: source } = t0;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    let t1;
    if ($[0] !== isNav4Enabled) {
        t1 = isNav4Enabled ? (0, $2to2n.NAV4_POPOVER_OFFSET) : [
            0,
            6
        ];
        $[0] = isNav4Enabled;
        $[1] = t1;
    } else t1 = $[1];
    const offset = t1;
    let t2;
    if ($[2] !== offset || $[3] !== source || $[4] !== spaceKey) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bb63054715080228$export$e1b8a1ae03e64401, {
            spaceKey: spaceKey,
            source: source,
            isTreeItem: true,
            offset: offset,
            placement: "bottom-start",
            shouldRenderToParent: true
        });
        $[2] = offset;
        $[3] = source;
        $[4] = spaceKey;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== ssrPlaceholderIdProp || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "page-tree-create-button",
            "data-vc": "page-tree-create-button",
            ...ssrPlaceholderIdProp
        }, t2);
        $[6] = ssrPlaceholderIdProp;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ spaceKey: spaceKey, source: source })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const offset = isNav4Enabled ? (0, $2to2n.NAV4_POPOVER_OFFSET) : [
        0,
        6
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "page-tree-create-button",
        "data-vc": "page-tree-create-button",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bb63054715080228$export$e1b8a1ae03e64401, {
        spaceKey: spaceKey,
        source: source,
        isTreeItem: true,
        offset: offset,
        placement: "bottom-start",
        shouldRenderToParent: true
    }));
};
module.exports["ContextualCreateContentPopoverLoader"] = $bb63054715080228$export$e1b8a1ae03e64401;
module.exports["TreeBottomCreateButton"] = $bb63054715080228$export$1546232e68d28255;

});

parcelRegister("a4AqN", function(module, exports) {

let $7556899598bc0153$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7556899598bc0153$var$load("hrbhL"),
    $7556899598bc0153$var$load("k8XPW"),
    $7556899598bc0153$var$load("fWCRm"),
    $7556899598bc0153$var$load("jTaSF"),
    $7556899598bc0153$var$load("6wr18"),
    $7556899598bc0153$var$load("kt4iH"),
    $7556899598bc0153$var$load("c0kqt"),
    $7556899598bc0153$var$load("k28dP"),
    $7556899598bc0153$var$load("fOF46"),
    $7556899598bc0153$var$load("iAqyW"),
    $7556899598bc0153$var$load("jbxHq"),
    $7556899598bc0153$var$load("fD0v8"),
    $7556899598bc0153$var$load("6XCf4"),
    $7556899598bc0153$var$load("1qlDN"),
    $7556899598bc0153$var$load("1yVM6"),
    $7556899598bc0153$var$load("5pvpJ"),
    $7556899598bc0153$var$load("jXx9i"),
    $7556899598bc0153$var$load("7EorR"),
    $7556899598bc0153$var$load("7u4WP"),
    $7556899598bc0153$var$load("ffEVr"),
    $7556899598bc0153$var$load("iqKwT"),
    $7556899598bc0153$var$load("iZ4sC"),
    $7556899598bc0153$var$load("hhss7"),
    $7556899598bc0153$var$load("9F7vX")
]).then(()=>parcelRequire('k9zbN'));

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<634d8ca034d2498a989d5a4ffee872da>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("lqy4C", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $42omo.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("cLhhP", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $1P1Tu.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $9zUhf.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $9zUhf.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("eVXGa", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $1337beb96693807c$var$isAllowedToCreate = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
const $1337beb96693807c$export$1060ff57674ca8ef = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $1337beb96693807c$var$isAllowedToCreate(accessStatus);
};
module.exports["useIsAllowedToCreateWhiteboard"] = $1337beb96693807c$export$1060ff57674ca8ef;

});

parcelRegister("7EIq6", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jtuBN = parcelRequire("jtuBN");


var $iLgzu = parcelRequire("iLgzu");


var $7NtNc = parcelRequire("7NtNc");

const $649b778bbd82b1bb$export$1defcb29347f9ac6 = (0, $3u0dr.isReactCompilerActiveV1)() ? (spaceKey)=>{
    const $ = (0, $frIzR.c)(15);
    const t0 = spaceKey !== undefined;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== t0) {
        t2 = {
            skip: t0,
            variables: t1
        };
        $[1] = t0;
        $[2] = t2;
    } else t2 = $[2];
    const { data: defaultSpaceKeyData } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)(t2);
    const t3 = !spaceKey && !defaultSpaceKeyData;
    const t4 = spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id;
    let t5;
    if ($[3] !== t4) {
        t5 = {
            spaceKey: t4
        };
        $[3] = t4;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== t3 || $[6] !== t5) {
        t6 = {
            errorPolicy: "all",
            skip: t3,
            variables: t5
        };
        $[5] = t3;
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    const spaceEnabledContentTypesQueryOptions = t6;
    const { data: enabledContentTypesData } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $7NtNc.SpaceEnabledContentTypesQuery), spaceEnabledContentTypesQueryOptions);
    const isCreateWhiteboardEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isWhiteboardsEnabled);
    const isCreateBlogEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isBlogsEnabled);
    const isCreateDatabaseEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isDatabasesEnabled);
    const isCreateSmartLinkEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isEmbedsEnabled);
    const isCreateLiveDocEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isLivePagesEnabled);
    const isCreateFolderEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isFoldersEnabled);
    let t7;
    if ($[8] !== isCreateBlogEnabled || $[9] !== isCreateDatabaseEnabled || $[10] !== isCreateFolderEnabled || $[11] !== isCreateLiveDocEnabled || $[12] !== isCreateSmartLinkEnabled || $[13] !== isCreateWhiteboardEnabled) {
        t7 = {
            isCreateWhiteboardEnabled: isCreateWhiteboardEnabled,
            isCreateBlogEnabled: isCreateBlogEnabled,
            isCreateDatabaseEnabled: isCreateDatabaseEnabled,
            isCreateSmartLinkEnabled: isCreateSmartLinkEnabled,
            isCreateLiveDocEnabled: isCreateLiveDocEnabled,
            isCreateFolderEnabled: isCreateFolderEnabled
        };
        $[8] = isCreateBlogEnabled;
        $[9] = isCreateDatabaseEnabled;
        $[10] = isCreateFolderEnabled;
        $[11] = isCreateLiveDocEnabled;
        $[12] = isCreateSmartLinkEnabled;
        $[13] = isCreateWhiteboardEnabled;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
} : (spaceKey)=>{
    const { data: defaultSpaceKeyData } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)({
        skip: spaceKey !== undefined,
        variables: {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        }
    });
    const spaceEnabledContentTypesQueryOptions = {
        errorPolicy: 'all',
        skip: !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    };
    const { data: enabledContentTypesData } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $7NtNc.SpaceEnabledContentTypesQuery), spaceEnabledContentTypesQueryOptions);
    const isCreateWhiteboardEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isWhiteboardsEnabled);
    const isCreateBlogEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isBlogsEnabled);
    const isCreateDatabaseEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isDatabasesEnabled);
    const isCreateSmartLinkEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isEmbedsEnabled);
    const isCreateLiveDocEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isLivePagesEnabled);
    const isCreateFolderEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isFoldersEnabled);
    return {
        isCreateWhiteboardEnabled: isCreateWhiteboardEnabled,
        isCreateBlogEnabled: isCreateBlogEnabled,
        isCreateDatabaseEnabled: isCreateDatabaseEnabled,
        isCreateSmartLinkEnabled: isCreateSmartLinkEnabled,
        isCreateLiveDocEnabled: isCreateLiveDocEnabled,
        isCreateFolderEnabled: isCreateFolderEnabled
    };
};
module.exports["useSpaceEnabledContentTypes"] = $649b778bbd82b1bb$export$1defcb29347f9ac6;

});

parcelRegister("7NtNc", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $ada047e01258ab08$export$a08098e2700d7e94 = (0, $eSUdr.default)`query SpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id key spaceTypeSettings{enabledContentTypes{isBlogsEnabled isDatabasesEnabled isEmbedsEnabled isLivePagesEnabled isWhiteboardsEnabled isFoldersEnabled}}}}`;
module.exports["SpaceEnabledContentTypesQuery"] = $ada047e01258ab08$export$a08098e2700d7e94;

});

parcelRegister("lvOsp", function(module, exports) {

var $jxs8y = parcelRequire("jxs8y");


var $86okN = parcelRequire("86okN");

function $278c8d04dad7bc1d$export$363a8d7f501f3769(query, options) {
    return (0, $jxs8y.useLazyQuery)((0, $86okN.toDocumentNode)(query), options);
}
module.exports["useLazyQueryInterop"] = $278c8d04dad7bc1d$export$363a8d7f501f3769;

});

parcelRegister("lujnM", function(module, exports) {
/* link-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3hoG4 = parcelRequire("3hoG4");


var $3654r = parcelRequire("3654r");


var $dukN8 = parcelRequire("dukN8");


var $5ujhR = parcelRequire("5ujhR");


var $ZrrWT = parcelRequire("ZrrWT");

const $7e4278b3396cac85$var$listItemStyles = {
    root: "_10m98stt"
};
const $7e4278b3396cac85$var$LinkMenuItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $42omo.useRef)(null);
    (0, $ZrrWT.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $42omo.useMemo)(()=>{
        return (0, $3654r.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dukN8.ListItem), {
        ref: ref,
        xcss: $7e4278b3396cac85$var$listItemStyles.root,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5ujhR.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
};
const $7e4278b3396cac85$export$d2cad7a1cce7b35f = (0, $3hoG4.default)($7e4278b3396cac85$var$LinkMenuItemNoRef);
module.exports["LinkMenuItem"] = $7e4278b3396cac85$export$d2cad7a1cce7b35f;

});

parcelRegister("6adZX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $059c9f3c8066ba5d$var$initialState = {
    openFlyoutId: null
};
const $059c9f3c8066ba5d$export$3d79379112bcd772 = (0, $1P1Tu.createStore)({
    name: 'FlyoutStore',
    initialState: $059c9f3c8066ba5d$var$initialState,
    actions: {
        openFlyout: (menuId)=>({ setState: setState })=>{
                setState({
                    openFlyoutId: menuId
                });
            },
        closeFlyout: (menuId = null)=>({ setState: setState, getState: getState })=>{
                if (!menuId || menuId === getState().openFlyoutId) setState({
                    openFlyoutId: null
                });
            }
    }
});
const $059c9f3c8066ba5d$export$377168f986312a4 = (0, $9zUhf.createHook)($059c9f3c8066ba5d$export$3d79379112bcd772, {
    selector: (state, menuId)=>state.openFlyoutId === menuId
});
const $059c9f3c8066ba5d$export$3f64b5809402b3ff = (menuId)=>{
    const [isFlyoutOpen, flyoutActions] = $059c9f3c8066ba5d$export$377168f986312a4(menuId);
    const openFlyout = (0, $42omo.useCallback)(()=>flyoutActions.openFlyout(menuId), [
        flyoutActions,
        menuId
    ]);
    const closeFlyout = (0, $42omo.useCallback)(()=>flyoutActions.closeFlyout(menuId), [
        flyoutActions,
        menuId
    ]);
    return {
        isFlyoutOpen: isFlyoutOpen,
        openFlyout: openFlyout,
        closeFlyout: closeFlyout
    };
};
const $059c9f3c8066ba5d$export$285f2f1642666795 = (0, $9zUhf.createActionsHook)($059c9f3c8066ba5d$export$3d79379112bcd772);
module.exports["useIsFlyoutOpen"] = $059c9f3c8066ba5d$export$377168f986312a4;
module.exports["useFlyout"] = $059c9f3c8066ba5d$export$3f64b5809402b3ff;
module.exports["useFlyoutActions"] = $059c9f3c8066ba5d$export$285f2f1642666795;

});

parcelRegister("cbBHq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lvOsp = parcelRequire("lvOsp");


var $9wGTI = parcelRequire("9wGTI");


var $2PxwR = parcelRequire("2PxwR");


var $5Cllo = parcelRequire("5Cllo");

const $0b3da77a55c8d66c$export$47d6a944ca09299 = ()=>{
    const [preloadSmartCreationModalQuery] = (0, $lvOsp.useLazyQueryInterop)((0, $5Cllo.ConfluenceSmartCreationModalQuery));
    return (0, $42omo.useCallback)(()=>{
        if ((0, $9wGTI.fg)('aifc_create_enabled')) {
            preloadSmartCreationModalQuery();
            (0, $2PxwR.LazyConfluenceSmartCreationModal).preload();
        }
    }, [
        preloadSmartCreationModalQuery
    ]);
};
module.exports["usePreloadSmartCreationModal"] = $0b3da77a55c8d66c$export$47d6a944ca09299;

});

parcelRegister("2PxwR", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c156286aa1d634b0$export$116ded32e65c3603 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "4mwBk",
    name: "LazyConfluenceSmartCreationModal",
    loader: async ()=>(await (parcelRequire("lPCPj"))).ConfluenceSmartCreationModal
});
module.exports["LazyConfluenceSmartCreationModal"] = $c156286aa1d634b0$export$116ded32e65c3603;

});

parcelRegister("lPCPj", function(module, exports) {

let $fe4c7a8eb3d4e600$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fe4c7a8eb3d4e600$var$load("h3ABO"),
    $fe4c7a8eb3d4e600$var$load("arB6f"),
    $fe4c7a8eb3d4e600$var$load("iZU4p"),
    $fe4c7a8eb3d4e600$var$load("jlSv2"),
    $fe4c7a8eb3d4e600$var$load("1UUrt"),
    $fe4c7a8eb3d4e600$var$load("2haIE"),
    $fe4c7a8eb3d4e600$var$load("9K4jq"),
    $fe4c7a8eb3d4e600$var$load("kUbUu"),
    $fe4c7a8eb3d4e600$var$load("8zjVx"),
    $fe4c7a8eb3d4e600$var$load("ew3vp"),
    $fe4c7a8eb3d4e600$var$load("kPclQ"),
    $fe4c7a8eb3d4e600$var$load("k8XPW"),
    $fe4c7a8eb3d4e600$var$load("fWCRm"),
    $fe4c7a8eb3d4e600$var$load("2YffH"),
    $fe4c7a8eb3d4e600$var$load("4WLYZ"),
    $fe4c7a8eb3d4e600$var$load("7k2Wx"),
    $fe4c7a8eb3d4e600$var$load("R7cS6"),
    $fe4c7a8eb3d4e600$var$load("fJtJG"),
    $fe4c7a8eb3d4e600$var$load("aKcjp"),
    $fe4c7a8eb3d4e600$var$load("icsuN"),
    $fe4c7a8eb3d4e600$var$load("fjMho"),
    $fe4c7a8eb3d4e600$var$load("9w0Re"),
    $fe4c7a8eb3d4e600$var$load("1wQU1"),
    $fe4c7a8eb3d4e600$var$load("ikQAz"),
    $fe4c7a8eb3d4e600$var$load("eBY1U"),
    $fe4c7a8eb3d4e600$var$load("dUz9k"),
    $fe4c7a8eb3d4e600$var$load("cyGuT"),
    $fe4c7a8eb3d4e600$var$load("lYvov"),
    $fe4c7a8eb3d4e600$var$load("9XYQ9"),
    $fe4c7a8eb3d4e600$var$load("3EXzu"),
    $fe4c7a8eb3d4e600$var$load("4USmq"),
    $fe4c7a8eb3d4e600$var$load("76QD0"),
    $fe4c7a8eb3d4e600$var$load("b2FtX"),
    $fe4c7a8eb3d4e600$var$load("hrbhL"),
    $fe4c7a8eb3d4e600$var$load("aeEUI"),
    $fe4c7a8eb3d4e600$var$load("eY3St"),
    $fe4c7a8eb3d4e600$var$load("bkd4T"),
    $fe4c7a8eb3d4e600$var$load("hshEG"),
    $fe4c7a8eb3d4e600$var$load("jTaSF"),
    $fe4c7a8eb3d4e600$var$load("9YBgR"),
    $fe4c7a8eb3d4e600$var$load("7ZIlR"),
    $fe4c7a8eb3d4e600$var$load("8fXIr"),
    $fe4c7a8eb3d4e600$var$load("dVkhd"),
    $fe4c7a8eb3d4e600$var$load("hhss7"),
    $fe4c7a8eb3d4e600$var$load("6wr18"),
    $fe4c7a8eb3d4e600$var$load("kjZZD"),
    $fe4c7a8eb3d4e600$var$load("9ZAzg"),
    $fe4c7a8eb3d4e600$var$load("kJSYP"),
    $fe4c7a8eb3d4e600$var$load("3ySTn"),
    $fe4c7a8eb3d4e600$var$load("c2rHL"),
    $fe4c7a8eb3d4e600$var$load("8m8aj"),
    $fe4c7a8eb3d4e600$var$load("lT67w"),
    $fe4c7a8eb3d4e600$var$load("8lj0L"),
    $fe4c7a8eb3d4e600$var$load("Wowvf"),
    $fe4c7a8eb3d4e600$var$load("ffEVr"),
    $fe4c7a8eb3d4e600$var$load("kAAjo"),
    $fe4c7a8eb3d4e600$var$load("fbRdC"),
    $fe4c7a8eb3d4e600$var$load("gZGoR"),
    $fe4c7a8eb3d4e600$var$load("iqKwT"),
    $fe4c7a8eb3d4e600$var$load("efnul"),
    $fe4c7a8eb3d4e600$var$load("bgHzk"),
    $fe4c7a8eb3d4e600$var$load("7EorR"),
    $fe4c7a8eb3d4e600$var$load("fQKYr")
]).then(()=>parcelRequire('6CLTo'));

});

parcelRegister("5Cllo", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $282624469d1d8eb2$export$4f9d75f33ae603ea = (0, $eSUdr.gql)`query ConfluenceSmartCreationModalQuery{user:confluence_atlassianUser(current:true){id title}}`;
module.exports["ConfluenceSmartCreationModalQuery"] = $282624469d1d8eb2$export$4f9d75f33ae603ea;

});

parcelRegister("iI2ST", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $5ujhR = parcelRequire("5ujhR");


var $jjpBv = parcelRequire("jjpBv");

const $d3e054ddee411308$export$6dc09b7c0ec1dfcd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jjpBv.MenuListItem), {
        ref: listItemRef,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5ujhR.MenuItemBase), {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            /**
					 * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
					 * so they aren't rendered in the disabled state.
					 */ actions: isDisabled ? undefined : actions,
            actionsOnHover: isDisabled ? undefined : actionsOnHover,
            onClick: onClick,
            ariaControls: (0, $dh538.fg)('platform-dst-buttonmenuitem-selected-state-support') ? ariaControls : undefined,
            ariaExpanded: (0, $dh538.fg)('platform-dst-buttonmenuitem-selected-state-support') ? ariaExpanded : undefined,
            ariaHasPopup: (0, $dh538.fg)('platform-dst-buttonmenuitem-selected-state-support') ? ariaHasPopup : undefined,
            isSelected: (0, $dh538.fg)('platform-dst-buttonmenuitem-selected-state-support') ? isSelected : undefined,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});
module.exports["ButtonMenuItem"] = $d3e054ddee411308$export$6dc09b7c0ec1dfcd;

});

parcelRegister("6PMed", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $jxs8y = parcelRequire("jxs8y");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $eVXGa = parcelRequire("eVXGa");

const $bd992de7e8ae5757$var$usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery = (0, $eSUdr.default)`query usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery{paywallContentToDisable(contentType:"whiteboard"){deactivationIdentifier link title}}`;
const $bd992de7e8ae5757$export$305839d0d8489bf4 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const isAllowedToCreateWhiteboard = (0, $eVXGa.useIsAllowedToCreateWhiteboard)();
    const [preloadWhiteboardPaywallData] = (0, $jxs8y.useLazyQuery)($bd992de7e8ae5757$var$usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery);
    const shouldPreloadPaywallData = isAllowedToCreateWhiteboard && !isPremium;
    return (0, $42omo.useCallback)(()=>{
        if (shouldPreloadPaywallData) preloadWhiteboardPaywallData();
    }, [
        preloadWhiteboardPaywallData,
        shouldPreloadPaywallData
    ]);
};
module.exports["usePreloadCreationMenuData"] = $bd992de7e8ae5757$export$305839d0d8489bf4;

});

parcelRegister("gsXbX", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $4rwCt = parcelRequire("4rwCt");


var $4KS7f = parcelRequire("4KS7f");


var $g5gZt = parcelRequire("g5gZt");


var $lBYCH = parcelRequire("lBYCH");


var $gz8ZY = parcelRequire("gz8ZY");


var $jmjWc = parcelRequire("jmjWc");


var $6PMed = parcelRequire("6PMed");


var $lLaRd = parcelRequire("lLaRd");


const $18414c638d573189$var$CreateButton = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xnuWz",
    name: "CreateButton",
    loader: async ()=>(await (parcelRequire("iuxws"))).CreateButton
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $18414c638d573189$var$CreateContentButtonTextWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1nu9 _12wkglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1nu9 _12wkglyw",
            __cmplp.className
        ])
    });
});
const $18414c638d573189$var$i18n = (0, $cgtv4.defineMessages)({
    create: {
        id: "create-blank-fabric-page.create.content.popover.button",
        defaultMessage: "Create"
    },
    createContentLabel: {
        id: "create-blank-fabric-page.create.content.aria.label",
        defaultMessage: "Create content"
    }
});
const $18414c638d573189$export$256eebed8e934f30 = (createButtonTheme)=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...createButtonTheme.default,
                margin: 0,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ':hover': createButtonTheme.hover,
                ':focus': createButtonTheme.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && createButtonTheme.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };
const $18414c638d573189$export$dff01287f8ba179f = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { triggerProps: triggerProps, onClick: onClick } = t0;
    const { ref: ref } = triggerProps;
    const intl = (0, $8C5kA.default)();
    const { theme: theme, createContentPopoverButtonRef: createContentPopoverButtonRef } = (0, $42omo.useContext)((0, $lBYCH.AppNavigationContext));
    const preloadCreationMenuData = (0, $6PMed.usePreloadCreationMenuData)();
    let t1;
    if ($[0] !== onClick) {
        t1 = ()=>{
            onClick();
        };
        $[0] = onClick;
        $[1] = t1;
    } else t1 = $[1];
    const handleClick = t1;
    let t2;
    if ($[2] !== theme) {
        t2 = theme?.mode?.create ? $18414c638d573189$export$256eebed8e934f30(theme.mode.create) : undefined;
        $[2] = theme;
        $[3] = t2;
    } else t2 = $[3];
    const buttonTheme = t2;
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    let t3;
    if ($[4] !== buttonTheme || $[5] !== createContentPopoverButtonRef || $[6] !== handleClick || $[7] !== intl || $[8] !== isNav4Enabled || $[9] !== triggerProps) {
        const createButton = isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($18414c638d573189$var$CreateButton, {
            onClick: handleClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $18414c638d573189$var$i18n.create)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
            appearance: "primary",
            theme: buttonTheme,
            onClick: handleClick,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lLaRd.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                spacing: "spacious",
                label: "",
                "data-vc": "global-content-create-button"
            })),
            testId: "create-content-popover-button",
            ...triggerProps,
            "aria-label": intl.formatMessage($18414c638d573189$var$i18n.createContentLabel),
            ref: createContentPopoverButtonRef ? (0, $4rwCt.mergeRefs)([
                triggerProps.ref,
                createContentPopoverButtonRef
            ]) : triggerProps.ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($18414c638d573189$var$CreateContentButtonTextWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $18414c638d573189$var$i18n.create)));
        t3 = ()=>createButton;
        $[4] = buttonTheme;
        $[5] = createContentPopoverButtonRef;
        $[6] = handleClick;
        $[7] = intl;
        $[8] = isNav4Enabled;
        $[9] = triggerProps;
        $[10] = t3;
    } else t3 = $[10];
    const getCreateButton = t3;
    let t4;
    if ($[11] !== getCreateButton) {
        t4 = getCreateButton();
        $[11] = getCreateButton;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== isNav4Enabled || $[14] !== preloadCreationMenuData || $[15] !== ref || $[16] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lLaRd.CreateContentButtonWrapper), {
            "data-vc": "create-content-button-wrapper",
            ref: ref,
            onMouseEnter: preloadCreationMenuData,
            onFocus: preloadCreationMenuData,
            isNav4Enabled: isNav4Enabled
        }, t4);
        $[13] = isNav4Enabled;
        $[14] = preloadCreationMenuData;
        $[15] = ref;
        $[16] = t4;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
} : ({ triggerProps: triggerProps, onClick: onClick })=>{
    const { ref: ref } = triggerProps;
    const intl = (0, $8C5kA.default)();
    const { theme: theme, createContentPopoverButtonRef: createContentPopoverButtonRef } = (0, $42omo.useContext)((0, $lBYCH.AppNavigationContext));
    const preloadCreationMenuData = (0, $6PMed.usePreloadCreationMenuData)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        onClick();
    }, [
        onClick
    ]);
    const buttonTheme = theme?.mode?.create ? $18414c638d573189$export$256eebed8e934f30(theme.mode.create) : undefined;
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const createButton = isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($18414c638d573189$var$CreateButton, {
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $18414c638d573189$var$i18n.create)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        appearance: "primary",
        theme: buttonTheme,
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lLaRd.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
            spacing: "spacious",
            label: "",
            "data-vc": "global-content-create-button"
        })),
        testId: "create-content-popover-button",
        ...triggerProps,
        "aria-label": intl.formatMessage($18414c638d573189$var$i18n.createContentLabel),
        ref: createContentPopoverButtonRef ? (0, $4rwCt.mergeRefs)([
            triggerProps.ref,
            createContentPopoverButtonRef
        ]) : triggerProps.ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($18414c638d573189$var$CreateContentButtonTextWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $18414c638d573189$var$i18n.create)));
    const getCreateButton = ()=>{
        return createButton;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lLaRd.CreateContentButtonWrapper), {
        "data-vc": "create-content-button-wrapper",
        ref: ref,
        onMouseEnter: preloadCreationMenuData,
        onFocus: preloadCreationMenuData,
        isNav4Enabled: isNav4Enabled
    }, getCreateButton());
};
module.exports["GlobalCreateContentButton"] = $18414c638d573189$export$dff01287f8ba179f;

});

parcelRegister("lLaRd", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $35d2916df5304fc4$export$feec4094f6279c08 = 1129;
const $35d2916df5304fc4$export$be58b4326e23250f = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _18u0r5cr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _18u0r5cr",
            __cmplp.className
        ])
    });
});
const $35d2916df5304fc4$export$bfe3a25e72ae6442 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isNav4Enabled: isNav4Enabled, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1y3ozwfg _1qbpzwfg _7bqgzwfg _9kv71tcg _1i0i1tcg _1f1h1tcg _1n3cidpf _113jidpf _1kzlidpf",
            !__cmplp.isNav4Enabled && "_18u0utpp",
            __cmplp.isNav4Enabled ? "_859hu2gc _1wkzu2gc _bgw9u2gc" : "_859hutpp _1wkzutpp _bgw9utpp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNav4Enabled: isNav4Enabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1y3ozwfg _1qbpzwfg _7bqgzwfg _9kv71tcg _1i0i1tcg _1f1h1tcg _1n3cidpf _113jidpf _1kzlidpf",
            !__cmplp.isNav4Enabled && "_18u0utpp",
            __cmplp.isNav4Enabled ? "_859hu2gc _1wkzu2gc _bgw9u2gc" : "_859hutpp _1wkzutpp _bgw9utpp",
            __cmplp.className
        ])
    });
});
module.exports["IconWrapper"] = $35d2916df5304fc4$export$be58b4326e23250f;
module.exports["CreateContentButtonWrapper"] = $35d2916df5304fc4$export$bfe3a25e72ae6442;

});

parcelRegister("iuxws", function(module, exports) {

let $d765083325dcef4c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d765083325dcef4c$var$load("6wr18"),
    $d765083325dcef4c$var$load("kFEyO"),
    $d765083325dcef4c$var$load("hLjS5"),
    $d765083325dcef4c$var$load("48rvp"),
    $d765083325dcef4c$var$load("iMSgb"),
    $d765083325dcef4c$var$load("hhss7"),
    $d765083325dcef4c$var$load("7EorR"),
    $d765083325dcef4c$var$load("ffEVr"),
    $d765083325dcef4c$var$load("dnVDi")
]).then(()=>parcelRequire('ePUmE'));

});


//# sourceMappingURL=TreeBottomCreateButton.9a458302.js.map
